module.exports = __webpack_public_path__ + "static/Middle School-1d56902244b16014053811d7fa669c30.png";